<template>
  <b-container>
    <div>
      <h2>Formulário: {{ form.formName }}</h2>
    </div>
    <checklist-fill
      ref="teste"
      :checklist="form"
      :token="$store.getters.token"
      @finishFilling="getChecklistNew"
    >
    </checklist-fill>
  </b-container>
</template>
<script>
export default {
  name: "ModuleFillForm",
  props: {
    id: Number,
    moduleId: String,
    itemId: String,
  },
  components: {
    ChecklistFill: () =>
      import("@/components_rms/checklist/fill/ChecklistFill.vue"),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Formulário preenchido com sucesso",
      },
      isBusy: false,
      form: [],
    };
  },
  created() {
    this.getChecklistNew();
  },
  methods: {
    getChecklistNew() {
      this.$apiChecklist
        .get(`/v2/checklist/toFill?formId=${this.id}&loadIntegrations=false`)
        .then((response) => {
          this.form = response.data.data;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
          console.log(error);
          console.log(error.response.data.errors);

          return null;
        });
    },
  },
};
</script>
